export const actionChangeHandelModalAddDiscountCode = (statusShow) => ({
    type: 'CHANGE_HANDLE_MODAL_ADD_DISCOUNT_CODE',statusShow
});
export const actionChangeInputsModalAddDiscountCode = (name,value) => ({
    type: 'CHANGE_INPUTS_MODAL_ADD_DISCOUNT_CODE',name,value
});
export const actionRefreshModalAddDiscountCode = () => ({
    type: 'REFRESH_MODAL_ADD_DISCOUNT_CODE',
});
